// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterBar_wrapper__2XuY5","container":"FooterBar_container__10o8T"};